export { VerticalRule } from './vertical-rule';
